/**
 * DV-3735: a floor plan is a photo whose caption says so. There is no asset
 * type or flag for it — asset-service's public gallery splits a photoset the
 * same way (`PublicGalleryServiceImpl.FLOOR_PLAN_CAPTION`, a case-insensitive
 * `floor\s*plan` find), and this pattern mirrors it so the Floor Plan tab and
 * the gallery's floor-plan strip always hold the same photos.
 *
 * Caption-matched on purpose for now (Tim, ClickUp DV-3735): a caption a client
 * edits to "Main Level" takes that photo off the tab. A real floor-plan marker
 * is a backlog follow-up.
 */
// Java's `\s` is ASCII whitespace only; JS's also takes a no-break space and
// the other Unicode spaces. Spelled out so a "Floor\u00A0Plan" pasted from
// Word is a floor plan on neither side, not on this one alone.
const FLOOR_PLAN_CAPTION_PATTERN = /floor[ \t\n\v\f\r]*plan/i;

/** The caption every Floor Plan tab upload is created with. */
export const FLOOR_PLAN_CAPTION = 'Floor Plan';

export const isFloorPlan = (asset: { caption?: string | null }): boolean =>
  FLOOR_PLAN_CAPTION_PATTERN.test(asset.caption ?? '');
